import { Typography } from '@mui/material';
import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';

const CreditLineSteps = (props: any) => {
  const { selectedRequest, status, type } = props;

  const missingDocuments = selectedRequest.documents.filter(
    (x: any) => !x.active,
  ).length;

  switch (status) {
    case 'Creada':
      if (type === 'Recieved') {
        return (
          <Typography>
            Se ha creado la solicitud, está siendo procesada por el bot de
            riesgo.
          </Typography>
        );
      } else {
        return (
          <Typography>
            Has enviado tu solicitud, se está a la espera de que nuestros
            analistas la reciban.
          </Typography>
        );
      }
      break;
    case 'En revisión':
      if (type === 'Recieved') {
        return (
          <Typography>
            La solicitud está siendo revisada por nuestros analistas.
          </Typography>
        );
      } else {
        return (
          <Typography>
            La solicitud ha sido enviada a la empresa. Esta está siendo revisada
            por nuestros mejores analistas.
          </Typography>
        );
      }
      break;
    case 'Faltan datos':
      if (type === 'Recieved') {
        return (
          <Typography>
            Estás a la espera de que el cliente te envíe más datos, de todas
            maneras, si lo requieres puedes aprobar o rechazar la operación
          </Typography>
        );
      } else {
        return (
          <Typography>
            El analista necesita más información para poder continuar con la
            solicitud. Dentro del Chat podrás ver que necesita. Luego lo puedes
            subir en Archivos.
          </Typography>
        );
      }
      break;
    case 'Revisada':
      if (type === 'Recieved') {
        return (
          <Typography>
            La solicitud ya fue revisada por riesgo, ahora debes asignarle la
            tasa.
          </Typography>
        );
      } else {
        return (
          <Typography>
            Tu solicitud ya fue revisada por nuestra área de riesgo, en estos
            minutos se le está asignando la tasa. Te notificaremos cuando esté
            lista.
          </Typography>
        );
      }
      break;
    case 'Cotizada':
      if (type === 'Recieved') {
        return (
          <Typography>
            Se ha enviado la solicitud al cliente. Te notificaremos cuando el
            cliente haya tomado la decisión.
          </Typography>
        );
      } else {
        return (
          <Typography>
            Esta es la solicitud de la empresa. A la derecha encontrarás la
            información resumida. Abajo está el detalle de la factura.
            {missingDocuments ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p
                  style={{
                    margin: '6px 0px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <ErrorIcon style={{ color: '#D62839', marginRight: '5px' }} />
                  No todas tus facturas están en la solicitud.
                </p>
              </div>
            ) : (
              <div />
            )}
          </Typography>
        );
      }
      break;
    case 'Aceptada':
      if (type === 'Recieved') {
        return (
          <Typography>
            El cliente aceptó la solicitud. Debes esperar a que ceda sus
            facturas. No dudes en contactarte con el.
          </Typography>
        );
      } else {
        return (
          <Typography>
            Has aceptado la solicitud. Ahora debes ceder tus facturas. Cualquier
            duda, puedes contactar a tu ejecutivo.
          </Typography>
        );
      }
      break;
    case 'Cancelada':
      if (type === 'Recieved') {
        return (
          <Typography>
            La solicitud ha sido cancelada por {selectedRequest.lastUserName}.
          </Typography>
        );
      } else {
        return (
          <Typography>
            La solicitud ha sido cancelada por {selectedRequest.lastUserName}.
          </Typography>
        );
      }
      break;
    case 'Rechazada':
      if (type === 'Recieved') {
        return <Typography>La solicitud ha sido rechazada.</Typography>;
      } else {
        return <Typography>La solicitud ha sido rechazada.</Typography>;
      }
      break;
    default:
      break;
    // case 'Confirmada':
    //   if (type === 'Recieved') {
    //     return <Typography >
    //               Has confirmado la solicitud que aceptó el cliente. Debes contactarte con
    //               el y solicitarle la cesión de sus facturas.
    //             </Typography>
    //   } else {
    //     return <Typography >
    //               La solicitud ha sido Confirmada por la empresa. Dentro de algunos minutos serás
    //               contactado por tu ejecutivo. Cualquier duda, te dejamos su información.
    //             </Typography>
    //   }
    //   break;
  }
};

export default CreditLineSteps;
